import api from 'api-client'

const state = {
    reports: [],
    adminReports: [],
    report: null
}

const getters = {
    reports: state => state.reports,
    adminReports: state => state.adminReports,
    report: state => state.report
}

const mutations = {
    reports (state, reports) {
        return new Promise(resolve => {
            state.reports = reports
            resolve(reports)
        })
    },
    adminReports (state, adminReports) {
        return new Promise(resolve => {
            state.adminReports = adminReports
            resolve(adminReports)
        })
    },
    report(state, report) {
        state.report = report
    }
}

const actions = {
    getReportsForUser (state) {
        return api.findReportsForUser()
            .then(result => {
                state.commit('reports', result)
                state.dispatch('buildReportMenu', result)
            })
    },
    getReport (state, query) {
        return api.getReport(query)
            .then(result => state.commit('report', result))
    },
    getReports (state) {
        return api.getReports()
            .then(result => {
                state.commit('adminReports', result)
            })
    },
    newReport({ commit }, report) {
        return api.createReport(report)
            .then(() => commit('report', report))
    },
    updateReport ({ commit }, report) {
        return api.updateReport(report)
    },
    deleteReport({ dispatch }, id) {
        return api.deleteReportById(id)
            .then(() => dispatch('getReports'))
    }
}

export default {
    state, getters, mutations, actions
}
